export enum ArchiveKeepPeriodType {
  TEN_YEARS = 'TEN_YEARS',
  THIRTY_YEARS = 'THIRTY_YEARS',
  PERMANENT = 'PERMANENT',
}

export const ArchiveKeepPeriodTypeMap = {
  [ArchiveKeepPeriodType.TEN_YEARS]: '10年',
  [ArchiveKeepPeriodType.THIRTY_YEARS]: '30年',
  [ArchiveKeepPeriodType.PERMANENT]: '永久',
};

export const ArchiveKeepPeriodTypeOptions = [
  {
    label: ArchiveKeepPeriodTypeMap[ArchiveKeepPeriodType.PERMANENT],
    value: ArchiveKeepPeriodType.PERMANENT,
  },
  {
    label: ArchiveKeepPeriodTypeMap[ArchiveKeepPeriodType.THIRTY_YEARS],
    value: ArchiveKeepPeriodType.THIRTY_YEARS,
  },
  {
    label: ArchiveKeepPeriodTypeMap[ArchiveKeepPeriodType.TEN_YEARS],
    value: ArchiveKeepPeriodType.TEN_YEARS,
  },
];
